import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectUserInfo } from '@/store/api/Users/Users.selector'

export const ConfirmInformation = () => {
  const { t } = useTranslation()
  const { firstname, lastname, email } = useSelector(selectUserInfo)

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <p className="text-neutralColor text-xl font-medium">
          {t('dashboard.settings.confirmInformation.title')}
        </p>
      </div>
      <div className="flex items-center justify-between">
        <p className="text-base font-normal text-neutralColor">
          {t('dashboard.settings.confirmInformation.name')}
        </p>
        <p className="text-base font-normal text-neutralColor80">{firstname}</p>{' '}
      </div>
      <div className="flex items-center justify-between">
        <p className="text-base font-normal text-neutralColor">
          {t('dashboard.settings.confirmInformation.lastName')}
        </p>
        <p
          className={`text-base font-normal ${
            lastname ? 'text-neutralColor80' : 'text-dynamicRed'
          }`}
        >
          {lastname ||
            t('dashboard.settings.confirmInformation.lastNameRequired')}
        </p>{' '}
      </div>
      <div className="flex items-center justify-between">
        <p className="text-base font-normal text-neutralColor">
          {t('dashboard.settings.confirmInformation.email')}
        </p>
        <p className="text-base font-normal text-neutralColor80">{email}</p>
      </div>
    </div>
  )
}
